// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"142":"a99703bc","852":"a99703bc","943":"b07582d5"}[chunkId] + ".chunk.css";
};